import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({
    title: "页面不存在 - 黄金网站软件app免费",
    description: "你访问的页面不存在，返回首页或浏览全部黄金投资软件。",
  });

  return (
    <SiteLayout>
      <div className="container-page flex min-h-[60vh] flex-col items-center justify-center gap-4 py-20 text-center">
        <span className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</span>
        <h1 className="font-heading text-2xl font-bold text-foreground-950">页面不存在</h1>
        <p className="max-w-md text-sm text-foreground-600">
          你访问的页面可能已被移除或链接有误，返回首页或浏览全部软件继续探索吧。
        </p>
        <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="btn-primary">
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link to="/softwares" className="btn-ghost">
            <i className="ri-apps-2-line" />
            浏览全部软件
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}